import moment from 'moment'
import React, { Component } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatNumber } from '../../utils/utils'
import MultiSelector from './MultiSelector'

const customStyles = {
  header: {
    style: {
      minHeight: '56px',
    },
  },

  subHeader: {
    style: {
      backgroundColor: 'none',
      marginBottom: '10px',
    },
  },

  headRow: {
    style: {
      borderRadius: '5px',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      height: '40px',
      borderTopColor: defaultThemes.default.divider.default,
    },
  },

  headCells: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      backgroundColor: '#e5e5e9',
      '&:not(:last-of-type)': {
        // borderRightStyle: 'solid',
        // borderRightWidth: '1px',
        borderRightColor: defaultThemes.default.divider.default,
      },
    },
  },

  cells: {
    style: {
      '&:not(:last-of-type)': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: defaultThemes.default.divider.default,
      },
    },
  },
}

export class ReadingsTable extends Component {
  constructor(props) {
    super(props)

    const isPrint = this.props.isPrint
    let columns = []

    if (!this.props.operatorName) {
      columns.push({
        name: 'Operador',
        selector: 'operatorName',
        sortable: !isPrint,
        grow: 0.6,
        wrap: true,
      })
    }

    // function mergeConsumption(row, prefix) {
    //   let values = [
    //     formatNumber(row[prefix + 'Vazio'], 0),
    //     formatNumber(row[prefix + 'SuperVazio'], 0),
    //     formatNumber(row[prefix + 'Pontas'], 0),
    //     formatNumber(row[prefix + 'Cheias'], 0),
    //   ]

    //   return formatNumber(row[prefix + 'Total'], 0) + ' (' + values.join(' | ') + ')'
    // }
    function mergeConsumption(row, prefix) {
      let values = [
        formatNumber(row[prefix + 'Vazio'], 0),
        formatNumber(row[prefix + 'SuperVazio'], 0),
        formatNumber(row[prefix + 'Pontas'], 0),
        formatNumber(row[prefix + 'Cheias'], 0),
      ]

      return values.join(' | ')
    }

    columns = columns.concat([
      { name: 'Data Entrada', selector: 'fromDt', sortable: !isPrint, grow: 1.2 },
      { name: 'Data Saída', selector: 'toDt', sortable: !isPrint, grow: 1.2 },
      { name: 'SST', selector: 'sst', sortable: !isPrint, grow: 0.7 },
      { name: 'Comboio', selector: 'train', sortable: !isPrint, grow: 0.5 },
      { name: 'Frota', selector: 'fleet', sortable: !isPrint, grow: 0.6 },
      { name: 'Serviço', selector: 'service', sortable: !isPrint, grow: 0.6 },

      {
        name: 'Consumo',
        selector: 'consumptionTotal',
        sortable: !isPrint,
        format: (row) => formatNumber(row.consumptionTotal, 0),
      },
      {
        name: 'V | SV | P | C',
        grow: 1.2,
        selector: 'consumptionTotal',
        sortable: !isPrint,
        format: (row) => mergeConsumption(row, 'consumption'),
      },
      {
        name: 'Frenagem',
        selector: 'brakingTotal',
        sortable: !isPrint,
        format: (row) => formatNumber(row.brakingTotal, 0),
      },
      {
        name: 'V | SV | P | C',
        grow: 1.2,
        selector: 'brakingTotal',
        sortable: !isPrint,
        format: (row) => mergeConsumption(row, 'braking'),
      },
    ])

    // Format dates
    const data = this.props.readings

    data.forEach((d) => {
      d.fromDt = moment(d.fromDt).format('YYYY-MM-DD HH:mm')
      d.toDt = moment(d.toDt).format('YYYY-MM-DD HH:mm')
    })

    this.state = {
      filterText: '',
      data: data,
      columns: columns,
      isPrint: isPrint,
      filterOnColumns: columns.map((c) => c.name),
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filterText !== this.state.filterText || prevState.filterOnColumns !== this.state.filterOnColumns) {
      this.doFilter()
    }
  }

  onFilter = (text) => {
    this.setState({
      filterText: text,
    })
  }

  onSetFilterColumn = (columnNames) => {
    this.setState({
      filterOnColumns: columnNames,
    })
  }

  doFilter = () => {
    let filtered
    if (this.state.filterOnColumns) {
      let colnames = this.state.columns
        .filter((c) => this.state.filterOnColumns.includes(c.name))
        .map((c) => c.selector)
      filtered = this.props.readings.filter((row) =>
        colnames.some((c) => String(row[c]).toLowerCase().includes(this.state.filterText.toLowerCase()))
      )
    } else {
      filtered = this.props.readings.filter((row) =>
        Object.keys(row).some((key) => String(row[key]).toLowerCase().includes(this.state.filterText.toLowerCase()))
      )
    }

    this.setState({
      data: filtered,
      filterText: this.state.filterText,
    })
  }

  exportCsv = () => {
    this.props.exportCsv()
  }

  render() {
    return (
      <div className="section">
        <nav className="level">
          <div className="level-left">
            <div className="subtitle sie-title-container">
              <h1 className="subtitle ">Registos</h1>
              <h2 className="subtitle is-size-6">Passagens registadas em cada subestação de tracção</h2>
            </div>
          </div>

          <div className="level-right">
            <div className="level-item">
              {!this.state.isPrint && (
                <p className="control">
                  <button className="button is-primary" onClick={this.exportCsv}>
                    <span className="icon is-small">
                      <FontAwesomeIcon icon="file-csv" />
                    </span>
                    <span>Exportar para CSV</span>
                  </button>
                </p>
              )}
            </div>
          </div>
        </nav>

        <DataTable
          columns={this.state.columns}
          data={this.state.data}
          highlightOnHover={!this.state.isPrint}
          dense={true}
          customStyles={customStyles}
          noHeader
          pagination
          paginationPerPage={20}
          noDataComponent={
            <div style={{ padding: '28px' }}>Não existem valores que cumpram o filtro seleccionado.</div>
          }
          subHeader={!this.state.isPrint}
          subHeaderComponent={
            !this.state.isPrint && (
              <FilterComponent
                onFilter={this.onFilter}
                values={this.state.filterOnColumns}
                onSetFilterColumn={this.onSetFilterColumn}
                columns={this.state.columns.map((c) => c.name)}
              />
            )
          }
          fixedHeader={!this.state.isPrint}
          fixedHeaderScrollHeight="80vh"
        />
      </div>
    )
  }
}

class FilterComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filterText: '',
      selectedValues: [],
    }
  }

  onFilter = (e) => {
    this.setState({
      filterText: e.target.value,
    })
    this.props.onFilter(e.target.value)
  }

  onSetFilterColumn = (s) => {
    this.props.onSetFilterColumn(s)
  }

  onClear = () => {
    this.setState({ filterText: '' })
    this.props.onFilter('')
  }

  render() {
    return (
      <div>
        <div className="field has-addons">
          <div className="control mr-3" style={{ width: '200px' }}>
            <MultiSelector
              options={this.props.columns}
              selectedValues={this.props.values}
              name={'???'}
              onChange={this.onSetFilterColumn}
            />
          </div>
          <p className="control">
            <input
              className="input"
              type="text"
              placeholder="Pesquisar"
              value={this.state.filterText}
              onChange={this.onFilter}
            />
          </p>
          <p className="control">
            <button className="button" disabled={this.state.filterText.length === 0} onClick={this.onClear}>
              Limpar
            </button>
          </p>
        </div>
      </div>
    )
  }
}
